// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","overflow-hidden":"overflow-hidden-32s3pxeynnmfak8qf4zft2q8ub14zfp56vg9v47zk6xj7db9wk4dggx6z5yvt4md9fvu982fp93m2ktxev52bs5e79fcrb87m3eqn5g","loading":"loading-k5kwcpzmh3a1jbyfrws6ujbccmvmby6kfz1khzqgwzxjzumdpgegytmwwbw7858q3csm6j1z1vma7autabemkjebdw2j6z4bvys61m","pulse":"pulse-2swx9b6xcy5572tb78r3afq673fuxec7dd8fm1muv5cckdvk9qkqug875rnutw1239nsgp4121eda5d9y22614ur27r9zntn2ampfwe"};


//////////////////
// WEBPACK FOOTER
// ./src/index.module.scss
// module id = 714
// module chunks = 0